/**
 * Search modal: dynamic --search-offset based on actual header position.
 * Set on :root so dialog (in top layer) reliably inherits it.
 * When Search is triggered from within the menu drawer, close the drawer first.
 */
(function () {
  document.addEventListener('dialog:trigger:search', () => {
    const menuDrawer = document.querySelector('menu-drawer');
    if (menuDrawer?.querySelector('dialog[open]')) {
      document.dispatchEvent(new CustomEvent('dialog:force-close:menu-drawer'));
    }
  }, { capture: true });

  const updateSearchOffset = () => {
    const headerMenu = document.querySelector('header-menu');
    if (!headerMenu) return;

    const rect = headerMenu.getBoundingClientRect();
    const offset = Math.max(0, Math.ceil(rect.bottom) - 1);
    document.documentElement.style.setProperty('--search-offset-js', `${Math.max(0, offset)}px`);
  };

  ['search', 'localization'].forEach((name) => {
    document.addEventListener('dialog:open:' + name, () => {
      requestAnimationFrame(() => requestAnimationFrame(updateSearchOffset));
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    ['search', 'localization'].forEach((name) => {
      const dialogEl = document.querySelector('custom-dialog[data-name="' + name + '"]');
      if (!dialogEl) return;
      const observer = new MutationObserver(() => {
        if (dialogEl.querySelector('dialog[open]')) {
          requestAnimationFrame(() => requestAnimationFrame(updateSearchOffset));
        }
      });
      observer.observe(dialogEl, { attributes: true, subtree: true, attributeFilter: ['open'] });
    });
  });
})();
